import React from 'react';

export const CalendarIcon = () => {
    const calendar = process.env.PUBLIC_URL + '/img/calendario.svg';

    return (
        <img className="day-market-svg" src={calendar} alt='' />
    )
}